const FLASH_EVENT_NAME = "oomple:flash";

const safeWindow = () => {
  if (typeof window === "undefined") return null;
  return window;
};

const serializeParams = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(`${key}[]`, v));
    } else {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
};

const dispatchFlashEvent = (win, type, message) => {
  if (!win) return false;

  win.dispatchEvent(
    new CustomEvent(FLASH_EVENT_NAME, {
      detail: {
        type,
        message,
      },
    })
  );

  return true;
};

export default class Window {
  static flash = {
    error: (
      error,
      message = "An error has occurred. Please reload and try again."
    ) => {
      console.error("error", error);

      const win = safeWindow();
      const handled = dispatchFlashEvent(win, "alert", message);

      if (!handled && win && typeof win.flash === "function") {
        win.flash("alert", message);
      }
    },

    success: (message) => {
      const win = safeWindow();
      const flashMessage = message || "Success!";
      const handled = dispatchFlashEvent(win, "notice", flashMessage);

      if (!handled && win && typeof win.flash === "function") {
        win.flash("notice", flashMessage);
      }
    },
  };

  static open = (url, name = "_blank") => {
    const win = safeWindow();
    if (win) win.open(url, name);
  };

  static redirect = (url, windowOverride) => {
    const win = windowOverride || safeWindow();
    if (win) win.location.href = url;
  };

  static updateParams = (params) => {
    const win = safeWindow();
    if (!win) return;

    const query = serializeParams(params);
    const path = `${win.location.pathname}${query ? `?${query}` : ""}`;

    win.history.replaceState({ url: path }, document.title, path);
  };

  static pushParams = (params) => {
    const win = safeWindow();
    if (!win) return;

    const query = serializeParams(params);
    const path = `${win.location.pathname}${query ? `?${query}` : ""}`;

    win.history.pushState({ url: path }, document.title, path);
  };

  static currentDomain = () => {
    const win = safeWindow();
    return win ? win.location.origin : "";
  };
}

export {
  FLASH_EVENT_NAME,
};
